/**
 * Partner Types
 */
import { createTypes } from "../../CommonFunctions/ReduxHelper";

export const SET_SIGNATURE_PAD = createTypes("SIGNATURE/SET_SIGNATURE_PAD");
export const SET_SIGNATURE_TYPE = createTypes("SIGNATURE/SET_SIGNATURE_TYPE");
export const SET_SIGNATURE_EMPTY = createTypes("SIGNATURE/SET_SIGNATURE_EMPTY");



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/types.js